import { Controller } from "@hotwired/stimulus"
import Shepherd from "shepherd.js"
import { offset } from '@floating-ui/dom';

// Connects to data-controller="tours--email-series"
export default class extends Controller {
  connect() {
    this.build()
    this.tour.start()
    Shepherd.once('complete', this.createDismissal.bind(this))
    Shepherd.once('cancel', this.createDismissal.bind(this))
  }

  build() {
    this.tour = new Shepherd.Tour({
      defaultStepOptions: {
        cancelIcon: { enabled: true },
        // Override default z-index to ensure it is behind side_modal
        classes: 'box box--card z-9998',
        scrollTo: { behavior: 'smooth', block: 'center' }
      },
      useModalOverlay: true
    })

    this.tour.addStep({
      title: "Emails",
      text: "We've recently made some changes to emails!<i class='ml-2 text-amber-300 fa-duotone fa_icon fa-sparkles'></i>",
      buttons: [
        {
          action: this.tour.cancel,
          text: 'Skip',
          classes: 'btn btn-link-slate'
        },
        {
          text: 'Next',
          action: this.tour.next,
          classes: 'btn btn-solid'
        }
      ]
    })

    this.tour.addStep({
      title: "Email Series",
      text: "Build a drip or behavior-based email communication series.",
      attachTo: {
        element: "#email_series_links",
        on: 'bottom'
      },
      modalOverlayOpeningPadding: 10,
      modalOverlayOpeningRadius: 4,
      floatingUIOptions: {
        middleware: [offset(20)]
      },
      buttons: [
        {
          action: this.tour.back,
          text: 'Back',
          classes: 'btn btn-link-slate'
        },
        {
          text: 'Next',
          action: this.tour.next,
          classes: 'btn btn-solid'
        }
      ]
    })

    this.tour.addStep({
      title: "Single Emails",
      text: "You'll find all your single emails here now including the ones you've already created.",
      attachTo: {
        element: "#single_emails_tab",
        on: 'right'
      },
      extraHighlights: ['#single_emails_panel'],
      modalOverlayOpeningRadius: {
        bottomRight: 6,
        bottomLeft: 6,
        topRight: 6,
      },
      floatingUIOptions: {
        middleware: [offset(10)]
      },
      when: {
        show: () => {
          document.querySelector('#single_emails_tab').click();
        }
      },
      buttons: [
        {
          action: this.tour.back,
          text: 'Back',
          classes: 'btn btn-link-slate'
        },
        {
          text: 'Next',
          action: this.tour.next,
          classes: 'btn btn-solid'
        }
      ]
    })

    this.tour.addStep({
      title: "Stats Chart",
      text: "You can now see a chart of all emails sent over a certain time frame.",
      attachTo: {
        element: "#tb-comms_email_batches_recipients_chart",
        on: 'top'
      },
      modalOverlayOpeningRadius: 6,
      floatingUIOptions: {
        middleware: [offset(10)]
      },
      buttons: [
        {
          action: this.tour.back,
          text: 'Back',
          classes: 'btn btn-link-slate'
        },
        {
          text: 'Next',
          action: this.tour.next,
          classes: 'btn btn-solid'
        }
      ]
    })

    this.tour.addStep({
      title: "Single Email",
      text: "Create an email from this page instead of a list.",
      attachTo: {
        element: "#new_single_email_button",
        on: 'left'
      },
      modalOverlayOpeningRadius: 8,
      floatingUIOptions: {
        middleware: [offset(10)]
      },
      buttons: [
        {
          action: this.tour.back,
          text: 'Back',
          classes: 'btn btn-link-slate'
        },
        {
          text: 'Next',
          action: this.tour.next,
          classes: 'btn btn-solid'
        }
      ]
    })

    this.tour.addStep({
      title: "More Info on Email Series",
      text: `Click here to learn more about email series.<br><br>Thanks for using MortarStone!`,
      attachTo: {
        element: "#emails_help_button",
        on: 'bottom'
      },
      modalOverlayOpeningRadius: 8,
      floatingUIOptions: {
        middleware: [offset(10)]
      },
      buttons: [
        {
          action: this.tour.back,
          text: 'Back',
          classes: 'btn btn-link-slate'
        },
        {
          action: this.tour.complete,
          text: 'Finish',
          classes: 'btn btn-solid'
        }
      ]
    })
  }

  createDismissal() {
    fetch(
      this.url,
      {
        method: 'POST',
        body: JSON.stringify(this.body),
        credentials: 'include',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': this.csrfToken
        },
      }
    )
  }

  get body() {
    return { dismissal: { kind: 'emails' } }
  }

  get url() {
    return "/dismissals"
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  }
}
